<template>
    <v-dialog
        v-if="$rc.inIndustry('wine')"
        v-model="show_modal"
        max-width="800"
        persistent
        scrollable
    >
        <v-card>
            <v-card-title class="error white--text">
                <v-icon dark class="mr-2">mdi-alert-circle</v-icon>
                Emerging Carrier Issue
            </v-card-title>

            <v-card-text class="pt-4">
                <strong>Emerging Carrier Issue</strong>
                        
                <p
                    style="margin-top: 5px"
                >
                    We have recently observed some unusual carrier blocking affecting certain bulk messages &mdash; we are working with the major carriers to resolve the issue.  
                    To minimize the potential for any delivery problems <b><u>while we are working with the carriers to resolve this issue</u></b> we recommend adjusting the content of bulk messages 
                    to <b><u>avoid direct (explicit) promotion of alcohol sales or consumption</u></b>.  The carriers have told us that indirect promotion is acceptable.
                </p>

                <p>
                    For example, instead of
                </p>
                
                <p
                    style="margin-left: 25px"
                >
                    Today only, save 25% on all 2022 Cabernet Sauvignons at {website-address}
                </p> 
                
                <p>consider</p>
                
                <p
                    style="margin-left: 25px"
                >
                    Today only, special savings for our members like you.  To learn more: {website-address}
                </p>

                For more details <a href="https://redchirp.com/emerging-carrier-issue/" target="_blank">read our article</a>  
            </v-card-text>

            <v-card-actions class="shaded-light">
                <v-spacer />
                <v-btn
                    color="primary"
                    @click="onDismiss"
                >
                    I Understand
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import WineryCarrierAlertContent from '@/components/bulk/winery-carrier-alert-content.vue';

const STORAGE_KEY = 'winery_carrier_alert_dismissed';

export default {
    name: 'TempDisableWineriesFromSchedulingModal',

    /*components: {
        WineryCarrierAlertContent,
    },*/

    data() {
        return {
            show_details: false,
            show_modal: false,
        };
    },

    mounted() {
        this.checkShouldShow();
    },

    methods: {
        checkShouldShow() {
            const dismissed_date = localStorage.getItem(STORAGE_KEY);
            const today = new Date().toISOString().split('T')[0];

            if (dismissed_date !== today) {
                this.show_modal = true;
            }
        },

        onDismiss() {
            const today = new Date().toISOString().split('T')[0];
            localStorage.setItem(STORAGE_KEY, today);
            this.show_modal = false;
        },
    },
};
</script>

<style lang="scss" scoped>
a {
    color: var(--v-primary-base) !important;
    text-decoration: none;
}
</style>
